// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { Link } from 'react-router-dom'
import logo from 'images/comsearch-logo.png'
import DatabaseManagement from './DatabaseManagement'
import User from './User'

const Navigation = () => (
  <header className={'app-header'}>
    <div className={'display-flex justify-content-between align-items-center bg-white'}>
      <Link className={'header-logo'} id={'header-homeLink'} to={'/'}>
        <img src={logo} title={'ComSearch Logo'} alt={'Comsearch Logo'} />
      </Link>
      <div className={'navigation-menu flex-child-1-0-auto display-flex justify-content-around'}>
        <Link id={'header-menu-home'} to={'/'}>
          {'Home'}
        </Link>
        <Link id={'header-menu-projects-list'} to={'/project-management'}>
          {'Projects'}
        </Link>
        <DatabaseManagement />
      </div>
      <User />
    </div>
  </header>
)

Navigation.displayName = 'Navigation'

export default Navigation
